import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const carTypesManagementReducer = foxGridReducer(gridNames.carTypesManagement);

export default carTypesManagementReducer;
